var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurCustomers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 446.738,
    viewBox: "0 0 512 446.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OUR_CUSTOMERS",
    "data-name": "OUR CUSTOMERS",
    transform: "translate(0 -32.631)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_602",
    "data-name": "Ellipse 602",
    cx: 87,
    cy: 87,
    r: 87,
    transform: "translate(169 32.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_603",
    "data-name": "Ellipse 603",
    cx: 55,
    cy: 55,
    r: 55,
    transform: "translate(377 96.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_604",
    "data-name": "Ellipse 604",
    cx: 55,
    cy: 55,
    r: 55,
    transform: "translate(25 96.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19431",
    "data-name": "Path 19431",
    d: "M134.19,256.021c-21.65-17.738-41.257-15.39-66.29-15.39-37.44,0-67.9,30.28-67.9,67.49v109.21a29.384,29.384,0,0,0,29.41,29.3c70.026,0,61.59,1.267,61.59-3.02C91,366.225,81.834,309.474,134.19,256.021Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19432",
    "data-name": "Path 19432",
    d: "M279.81,241.03c-43.724-3.647-81.729.042-114.51,27.1-54.857,43.94-44.3,103.1-44.3,175.48a35.08,35.08,0,0,0,35.02,35.02c211.082,0,219.483,6.809,232-20.91,4.105-9.374,2.98-6.395,2.98-96.07,0-71.226-61.673-120.62-111.19-120.62Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19433",
    "data-name": "Path 19433",
    d: "M444.1,240.63c-25.17,0-44.669-2.324-66.29,15.39C429.775,309.076,421,361.955,421,443.61c0,4.314-7,3.02,60.54,3.02A30.432,30.432,0,0,0,512,416.29V308.12C512,270.91,481.54,240.63,444.1,240.63Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurCustomers);
export default __webpack_public_path__ + "static/media/our_customers.88529201cde7f5db4adc685669c2d61f.svg";
export { ForwardRef as ReactComponent };